import { HomeSignalSeverity } from '../Types/home-signal-severity.type';

export const HOME_SEVERITY_RANK: Record<HomeSignalSeverity, number> = {
  critical: 0,
  warning: 1,
  info: 2,
};

export const HOME_INVOICE_SAMPLE_SIZE = 5;
export const HOME_MILLISECONDS_PER_DAY = 86_400_000;

export const HOME_MORNING_UNTIL_HOUR = 12;
export const HOME_AFTERNOON_UNTIL_HOUR = 18;

export const HOME_CARD_EXPIRY_WARNING_DAYS = 60;
export const HOME_GLOBAL_ADMIN_SOFT_LIMIT = 4;
export const HOME_HEALTH_SCORE_CLEAR = 90;

export const HOME_LAUNCHER_LIMIT = 6;
export const HOME_SPOTLIGHT_MIN_QUERY_LENGTH = 2;
export const HOME_SPOTLIGHT_DIRECTORY_LIMIT = 5;
export const HOME_SPOTLIGHT_DESTINATION_LIMIT = 6;
export const HOME_SPOTLIGHT_DEBOUNCE_MS = 250;
export const HOME_UNPAID_INVOICE_STATUSES: readonly string[] = ['open', 'past_due', 'unpaid'];
export const HOME_ACTIVE_SUBSCRIPTION_STATUSES: readonly string[] = ['active', 'trialing', 'past_due'];
